import * as Sentry from "@sentry/react"
import { getStatsigClient } from "./statsig"

export const Events = {
  // Auth
  LOGIN_SUCCESS: "login_success",
  LOGOUT: "logout",

  // Navigation
  PAGE_VIEW: "page_view",
  SITE_SELECTED: "site_selected",

  // Map
  MAP_POINT_SELECTED: "map_point_selected",
  MAP_LAYER_TOGGLED: "map_layer_toggled",
  MAP_DIMENSION_CHANGED: "map_dimension_changed",

  // Analysis
  ANALYSIS_MODE_CHANGED: "analysis_mode_changed",
  CHANGE_DETECTION_RUN: "change_detection_run",
  FORECAST_RUN: "forecast_run",
  CORRELATION_RUN: "correlation_run",

  // CRUD
  ANNOTATION_CREATED: "annotation_created",
  THRESHOLD_CREATED: "threshold_created",

  // Errors
  API_ERROR: "api_error",
} as const

export function trackEvent(
  name: string,
  properties?: Record<string, unknown>,
) {
  const client = getStatsigClient()
  if (client) {
    client.logEvent(
      name,
      undefined,
      properties as Record<string, string> | undefined,
    )
  }

  Sentry.addBreadcrumb({
    category: "analytics",
    message: name,
    data: properties,
    level: "info",
  })
}
